import React from 'react';
import { useHistory } from 'react-router'
import { makeStyles, Container, TextField, Typography, Grid, Dialog, Button, InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import customAxios from "../../API/customAxios";
import { useIntl } from 'react-intl';
import { DialogTitle, globalDialogStyle, messageBoxDialogStyle, DialogContent } from '../../UIComponent/CommonStyle';
import moment from 'moment';
import { toNativeDate } from '../api/ApprovalAPI';

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...messageBoxDialogStyle(theme),
}));

export default function ConfirmBox({
    approveMode,
    leaveMode,
    handleClose,
    open,
    selectedRows,
    displayData,
    isApprove,
    tabIndex,
    cutOffDate,
}) {
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory()
    const [showAfterSubmittion, setShowAfterSubmittion] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [submitDisabled, setSubmitDisabled] = React.useState(false);
    const [submitButtonText, setSubmitButtonText] = React.useState(intl.formatMessage({ id: 'waring.yes' }));
    const [errorMessage, setErrorMessage] = React.useState('');
    const loadingTime = 3000;
    const approvalText = intl.formatMessage({ id: 'leave_approval.confirmation_approve' });
    const confirmMessage = intl.formatMessage({ id: 'leave_approval.approve_success_message' });

    const returnMessage = (apiErrorMessage) => {
        if (apiErrorMessage) {
            setErrorMessage(intl.formatMessage({ id: "error." + apiErrorMessage }));
        } else  {
            setErrorMessage(intl.formatMessage({ id: 'error.general_message' }));
        }
    }

    const handleSubmit = async (selectIndex, data) => {
        const selectedIds = data
            .filter(item => selectIndex.includes(item.dataIndex))
            .map(item => item.data[0]);

        setSubmitDisabled(true);
        setSubmitButtonText(intl.formatMessage({ id: 'waiting' }));

        try {
            const response = await customAxios.post('/batch_approve_cash_out', {
                ids: selectedIds,
                cutOffDate: moment(toNativeDate(cutOffDate)).format('YYYY-MM-DD')
            });

            setShowAfterSubmittion(true);
            if (response.data.code === 201 || response.status === 201) {
                setTimeout(() => {
                    history.push({
                        pathname: '/cash_out',
                        search: '?tabIndex=1'
                    });
                    handleClose();
                }, loadingTime);
            } else {
                setErrorMessage(intl.formatMessage({ id: 'error.general_message' }));
                setError(true);
                setTimeout(() => {
                    setShowAfterSubmittion(false);
                    handleClose();
                }, 6000);
            }
        } catch (error) {
            console.log('error', error);
            setErrorMessage(intl.formatMessage({ id: 'error.general_message' }));
            setError(true);
            setShowAfterSubmittion(true);
            setTimeout(() => {
                setShowAfterSubmittion(false);
                handleClose();
            }, 6000);
        }
    }

    return (
        <Container className={classes.container} variant="outlined">
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {intl.formatMessage({ id: 'confirmation' })}
                </DialogTitle>
                {!showAfterSubmittion ?
                    <DialogContent dividers>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography>{intl.formatMessage({ id: 'cash_out.confirmation' }, { selected: selectedRows.length, total: displayData.length })}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <div className={classes.yesButton}>
                                    <Button
                                        disabled={submitDisabled}
                                        variant="contained"
                                        style={{ backgroundColor: 'green', color: '#FFF' }}
                                        size="small"
                                        startIcon={<CheckCircleIcon />}
                                        onClick={e => { e.preventDefault(); handleSubmit(selectedRows, displayData) }}
                                    >
                                        {submitButtonText}
                                    </Button>
                                    <Button
                                        className={classes.noButton}
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        startIcon={<CancelIcon />}
                                        onClick={handleClose}
                                    >
                                        {intl.formatMessage({ id: 'waring.no' })}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    :
                    <DialogContent className={classes.afterSubmitPage} dividers>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {!isError ? <Typography className={classes.title}>{confirmMessage}</Typography> : <Typography className={classes.title}>{errorMessage}</Typography>}
                            </Grid>
                            <Grid item xs={12}>
                                {!isError ? <CheckCircleIcon style={{ fontSize: '100px', color: 'green' }} /> : <CancelIcon color="secondary" style={{ fontSize: '100px' }} />}
                            </Grid>
                        </Grid>
                    </DialogContent>
                }
            </Dialog>
        </Container>
    )
}
